import { getAllocationUtils } from './utils';
import sortByPrice from './sortByPrice';
import promotedVideoStrip from './promotedVideoStrip';
import { responsiveCarousels } from './responsiveCarousels/responsiveCarousels';
import { agenciesInListingsGD } from './agenciesInListingsGD';
import { hourlyBannerGuest, hourlyBannerUser } from './hourlyBannerUserAndGuest';
import { projectManagementBanner } from './projectManagementBanner';
import { adsPlacement } from './adsPlacements';
import { briefFloatingForm } from './briefFloatingForm';

const experiments = {
    sortByPrice,
    responsiveCarousels,
    promotedVideoStrip,
    agenciesInListingsGD,
    hourlyBannerGuest,
    hourlyBannerUser,
    projectManagementBanner,
    adsPlacement,
    briefFloatingForm,
};

export const clientExperiments = getAllocationUtils(experiments);
